import { render } from "./DefecationList.vue?vue&type=template&id=b621c590&ts=true"
import script from "./DefecationList.vue?vue&type=script&lang=ts"
export * from "./DefecationList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__